// @flow
/**
 * Created by Mike Chung on 2/12/18.
 */
import React, {Fragment} from "react";
import * as _ from "lodash";
import SsoUser from "../../model/sso/SsoUser";
import SsoUserTableRow from "./SsoUserTableRow";
import SendForgotPasswordEmailModal from "../../containers/sso/SendForgotPasswordEmailModal";
import ResendActivationEmailModal from "../../containers/sso/ResendActivationEmailModal";
import ActivateUserModal from "../../containers/sso/ActivateUserModal";
import Table from "../util/tables/Table";
import TableHeading from "../util/tables/TableHeading";
import TableRow from "../util/tables/TableRow";
import TableHead from "../util/tables/TableHead";
import TableBody from "../util/tables/TableBody";
import Paginator from "../Paginator";
import type {Location} from "../../types/ReactRouterTypes";
import {Country} from "../../model/Country";
import {Alert} from "reactstrap";
import Idle from 'react-idle';
import {connect} from "react-redux";
import {ssoUserQuerySuccessAction} from "../../actions/sso/creators/ssoUserQueryActionCreator";
import type {StoreState} from "../../reducers/combinedReducers";
import {computeUserConfigs} from "../../helpers/utils";
import type {RoleConfig} from "../../types/utilityTypes";

type SsoUserQueryResultStateProps = {
    idleTimeout: number
}

type SsoUserQueryResultProps = {
    ssoUsers: Array<SsoUser>,
    currentPage: number,
    totalCount: number,
    countries: Array<Country>,
    generatePageLink: (page: number) => Location,
    resetResult: () => any
} & SsoUserQueryResultStateProps;

function SsoUserQueryResultInternal(props: SsoUserQueryResultProps) {
    return (
        <div>
            <Table>
                <TableHeading>
                    <TableRow>
                        <TableHead>Company Name</TableHead>
                        <TableHead>First Name</TableHead>
                        <TableHead>Last Name</TableHead>
                        <TableHead>Country</TableHead>
                        <TableHead>E-mail</TableHead>
                        <TableHead>Create Date</TableHead>
                        <TableHead>Last Modify Date</TableHead>
                        <TableHead>Status</TableHead>
                        <TableHead>Action</TableHead>
                    </TableRow>
                </TableHeading>
                <TableBody>
                    {
                        _.map(props.ssoUsers, (user: SsoUser, i: number) => <SsoUserTableRow key={i} ssoUser={user} countries={props.countries}/>)
                    }
                </TableBody>
            </Table>

            <Paginator currentPage={props.currentPage} pageItem={20} totalCount={props.totalCount} generateLink={props.generatePageLink}/>
            <SendForgotPasswordEmailModal/>
            <ResendActivationEmailModal/>
            <ActivateUserModal/>
        </div>
    );
}

function IdleResult(props: SsoUserQueryResultProps) {
    return (
        <Idle onChange={(idle) => {
            if (idle.idle) {
                props.resetResult();
            }
        }}
              timeout={props.idleTimeout}
              render={({idle}) =>
            <Fragment>
                {idle
                    ? null
                    : <SsoUserQueryResult {...props}/>
                }
            </Fragment>
        }/>
    );
}

function SsoUserQueryResult(props: SsoUserQueryResultProps) {
    return props.totalCount > 0 ? (
        <SsoUserQueryResultInternal {...props} />
    ) : (<Alert color={"warning"}>No Record Found!</Alert>);
}

export default connect((state: StoreState): SsoUserQueryResultStateProps => {

    let roleConfig: RoleConfig = computeUserConfigs(state.loginUser.roleIds);
    return {
        idleTimeout: roleConfig.idleTimeout
    }

}, (dispatch) => {
    return {

        resetResult: () => {
            dispatch(ssoUserQuerySuccessAction([], -1));
        }
    };
})(IdleResult);


// WEBPACK FOOTER //
// ./src/components/sso/SsoUserQueryResult.js